import $ from 'jquery';

$(document).on('ready', function() {
	$('.contentItem').each(function() {
	  $(this).find('.modula-items').each(function() {
		var count = $(this).children().length;
		$(this).attr('data-count', count);
	  });
	});
});